import {
  Authenticate,
  RefreshAuth,
  GetPlayerGames,
  UpdateAttendance,
  GetPlayerGamesVotes,
  SubmitPlayerGameVotes,
  GetMonthlyStats,
  GetGameById,
  GetPlayerGroups,
  AuthMe,
  ResetPassword,
  ForgotPassword,
} from "./actions";

// We should remove "any" from here and use generic Type
const ActionsRegistry: { [key: string]: (params: any) => any } = {
  "/auth/login": Authenticate,
  "/auth/refresh": RefreshAuth,
  "/auth/me": AuthMe,
  "/auth/reset-password": ResetPassword,
  "/auth/forgot-password": ForgotPassword,
  "/players/{id}/games": GetPlayerGames,
  "/players/{id}/games/{gameId}/votes": GetPlayerGamesVotes,
  "/players/{id}/attendance/{attendanceId}": SubmitPlayerGameVotes,
  "/games/{id}": GetGameById,
  "/games/{id}/player/{playerId}/attendance": UpdateAttendance,
  "/stats": GetMonthlyStats,
  "/players/{id}/groups": GetPlayerGroups,
};

export default ActionsRegistry;
